<mat-card class="container mt-5">
    <p class="no-data py-5 mob-no-data">
        <img src="../../../assets/img/message.jpg" class="mx-auto d-block mb-5" alt="">
        Please contact <b class="h4">admin@aepcertification.com</b> in case if you face any challenges in enrolling for the certification or accessing your enrolled or completed certification details.
    </p>
</mat-card>